import React from 'react';

const C = {
  bg:'#08090f', card:'#0d1117', inp:'#0f1420',
  border:'#1f2937', borderS:'#1a2035',
  primary:'#e5e7eb', secondary:'#6b7280', muted:'#374151',
  profit:'#16C784', loss:'#ef4444', accent:'#6366f1',
};

function SDiv({ label }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:8, margin:'6px 0' }}>
      <div style={{ flex:1, height:1, background:C.borderS }}/>
      <span style={{ color:C.muted, fontSize:9, fontWeight:800, letterSpacing:2, textTransform:'uppercase' }}>{label}</span>
      <div style={{ flex:1, height:1, background:C.borderS }}/>
    </div>
  );
}

function SCard({ children, accent, style={} }) {
  return (
    <div style={{
      borderRadius:12, padding:'10px 12px', boxSizing:'border-box',
      background: accent ? `linear-gradient(135deg,${accent}12 0%,${C.card} 100%)` : C.card,
      border:`1px solid ${accent ? `${accent}28` : C.border}`, ...style,
    }}>
      {children}
    </div>
  );
}

function SHead({ emoji, title, color }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:8 }}>
      <div style={{ width:20, height:20, borderRadius:6, background:`${color||C.accent}22`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontSize:11 }}>
        {emoji}
      </div>
      <span style={{ color:C.primary, fontSize:11, fontWeight:800, textTransform:'uppercase', letterSpacing:1 }}>{title}</span>
    </div>
  );
}

function MC({ label, value, color }) {
  return (
    <div style={{ padding:'5px 8px', borderRadius:8, background:color?`${color}10`:C.inp, border:`1px solid ${color?`${color}22`:C.border}` }}>
      <div style={{ color:C.secondary, fontSize:8, fontWeight:600, marginBottom:1 }}>{label}</div>
      <div style={{ color:color||C.primary, fontSize:11, fontWeight:800, lineHeight:1.2 }}>{value??'—'}</div>
    </div>
  );
}

function Pill({ label, color }) {
  return (
    <span style={{ display:'inline-block', background:`${color}18`, color, border:`1px solid ${color}28`, borderRadius:20, padding:'2px 8px', fontSize:9, fontWeight:700, marginRight:3, marginBottom:3 }}>
      {label}
    </span>
  );
}

function ScannerShareCard({ snap, cardRef }) {
  if (!snap) return null;

  const {
    symbol='', company=null,
    scanner_label=snap?.scanner_name||'—',
    scanner_description='',
    direction='neutral',
    color:sigCol='#6366f1',
    triggered_at=null,
    strengthPct=null,
  } = snap;

  const sym       = symbol.replace('.NS','');
  const isBullish = direction==='bullish';
  const isBearish = direction==='bearish';
  const dirLabel  = isBullish?'BULLISH':isBearish?'BEARISH':'NEUTRAL';
  const dirCol    = isBullish?C.profit:isBearish?C.loss:'#f59e0b';

  const getAge = (ts) => {
    if (!ts) return null;
    const mins = Math.round((Date.now()-new Date(ts).getTime())/60000);
    if (mins<60) return `${mins}m ago`;
    if (mins<1440) return `${Math.floor(mins/60)}h ago`;
    return `${Math.floor(mins/1440)}d ago`;
  };
  const getFreshness = (ts) => {
    if (!ts) return { label:'Unknown', color:C.secondary };
    const mins = (Date.now()-new Date(ts).getTime())/60000;
    if (mins<30)  return { label:'Fresh',  color:C.profit };
    if (mins<240) return { label:'Recent', color:'#f59e0b' };
    return              { label:'Old',    color:C.loss };
  };

  const age       = getAge(triggered_at);
  const freshness = getFreshness(triggered_at);
  const dateStr   = triggered_at
    ? new Date(triggered_at).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})
    : new Date().toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'});

  const steps = [
    { n:'1', text:"Check the day's regime and global bias before entering.", color:'#06b6d4' },
    { n:'2', text:'Always set a stop loss below the recent swing low (bull) or above swing high (bear).', color:C.profit },
    { n:'3', text:isBullish?'Look for entry near support with 1:2+ R:R.':isBearish?'Look for entry near resistance with 1:2+ R:R.':'Wait for clearer direction before committing.', color:'#818cf8' },
  ];

  return (
    <div
      ref={cardRef}
      style={{
        width:1080, height:1350, background:C.bg, overflow:'hidden', position:'relative',
        fontFamily:"'Segoe UI',system-ui,-apple-system,sans-serif",
        display:'flex', flexDirection:'column', padding:28, gap:8, boxSizing:'border-box',
      }}
    >
      {/* Ambient glow */}
      <div style={{ position:'absolute', top:-80, right:-80, width:220, height:220, borderRadius:'50%', background:`radial-gradient(circle,${dirCol}0e 0%,transparent 65%)`, pointerEvents:'none' }}/>

      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8, flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:28, height:28, borderRadius:8, background:'linear-gradient(135deg,#22c55e30,#22c55e10)', border:'1px solid #22c55e35', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#22c55e', fontSize:14, fontWeight:900 }}>T</span>
          </div>
          <span style={{ color:'#fff', fontSize:16, fontWeight:800 }}>TradeReflex</span>
        </div>
        <span style={{ color:C.muted, fontSize:11 }}>{dateStr}</span>
        <span style={{ color:C.muted, fontSize:11 }}>tradereflex.in</span>
      </div>

      {/* Hero */}
      <SCard accent={dirCol}>
        <div style={{ marginBottom:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
            <span style={{ color:'#fff', fontSize:36, fontWeight:900, letterSpacing:'-1px', lineHeight:1 }}>{sym}</span>
            <span style={{ background:`${dirCol}18`, color:dirCol, border:`1px solid ${dirCol}28`, borderRadius:20, padding:'3px 10px', fontSize:10, fontWeight:900 }}>{dirLabel}</span>
          </div>
          {company && company!==sym && <p style={{ color:C.secondary, fontSize:12, margin:'0 0 6px' }}>{company}</p>}
          <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
            <Pill label={scanner_label} color={sigCol}/>
            <Pill label={freshness.label} color={freshness.color}/>
            {age && <Pill label={age} color={freshness.color}/>}
          </div>
        </div>
        <div style={{ background:`${dirCol}10`, border:`1px solid ${dirCol}20`, borderLeft:`3px solid ${dirCol}`, borderRadius:'0 8px 8px 8px', padding:'8px 12px' }}>
          <p style={{ color:C.primary, fontSize:12, lineHeight:1.5, margin:0 }}>
            {isBullish?'Bullish signals active — momentum building upward.':isBearish?'Bearish signals active — downward pressure building.':'Mixed signals. Wait for clearer directional confirmation.'}
          </p>
        </div>
      </SCard>

      {/* 2-column: Signal Details + Strength */}
      <div style={{ display:'flex', gap:8 }}>
        {/* Left: signal metrics */}
        <SCard style={{ flex:1 }}>
          <SHead emoji="📡" title="Signal Details" color={sigCol}/>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
            <MC label="Direction"  value={dirLabel}         color={dirCol}/>
            <MC label="Scanner"    value={scanner_label}    color={sigCol}/>
            {age && <MC label="Signal Age"  value={age}    color={freshness.color}/>}
            <MC label="Freshness"  value={freshness.label}  color={freshness.color}/>
            {strengthPct!=null && <MC label="Strength" value={`${strengthPct.toFixed(0)}%`} color={sigCol}/>}
          </div>
        </SCard>

        {/* Right: strength bar or scanner description */}
        <SCard accent={sigCol} style={{ flex:1 }}>
          <SHead emoji="💡" title={strengthPct!=null?'Signal Strength':'Scanner'} color={sigCol}/>
          {strengthPct!=null ? (
            <>
              <p style={{ color:C.secondary, fontSize:10, fontWeight:700, margin:'0 0 6px', letterSpacing:'0.8px' }}>SIGNAL STRENGTH</p>
              <div style={{ height:6, borderRadius:3, background:C.border, overflow:'hidden', marginBottom:6 }}>
                <div style={{ width:`${Math.min(100,strengthPct)}%`, height:'100%', background:`linear-gradient(90deg,${sigCol}80,${sigCol})`, borderRadius:3 }}/>
              </div>
              <p style={{ color:sigCol, fontSize:22, fontWeight:900, margin:0 }}>{strengthPct.toFixed(0)}%</p>
            </>
          ) : scanner_description ? (
            <p style={{ color:C.secondary, fontSize:11, lineHeight:1.55, margin:0 }}>{scanner_description.slice(0,200)}</p>
          ) : (
            <p style={{ color:C.muted, fontSize:11, margin:0 }}>No additional info</p>
          )}
        </SCard>
      </div>

      {/* 2-column: Scanner description + Trade Guide */}
      <div style={{ display:'flex', gap:8, flex:1 }}>
        {scanner_description && strengthPct!=null && (
          <SCard accent={sigCol} style={{ flex:1 }}>
            <SHead emoji="📡" title="About Scanner" color={sigCol}/>
            <p style={{ color:C.secondary, fontSize:11, lineHeight:1.55, margin:0 }}>{scanner_description.slice(0,300)}</p>
          </SCard>
        )}

        <SCard style={{ flex:1 }}>
          <SHead emoji="💡" title="Trade Guide" color="#f59e0b"/>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {steps.map(s => (
              <div key={s.n} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background:`${s.color}18`, border:`1.5px solid ${s.color}35`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <span style={{ color:s.color, fontSize:10, fontWeight:900 }}>{s.n}</span>
                </div>
                <p style={{ color:C.secondary, fontSize:11, margin:0, lineHeight:1.5, paddingTop:1 }}>{s.text}</p>
              </div>
            ))}
          </div>
        </SCard>
      </div>

      <p style={{ color:C.muted, fontSize:10, margin:'4px 0 0', textAlign:'center' }}>For educational purposes only — not financial advice</p>

      {/* Footer */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:8, borderTop:`1px solid ${C.borderS}`, flexShrink:0, marginTop:'auto' }}>
        <span style={{ color:C.muted, fontSize:10 }}>Know your edge · TradeReflex</span>
        <span style={{ color:C.secondary, fontSize:10, fontWeight:700 }}>tradereflex.in</span>
      </div>
    </div>
  );
}

export default ScannerShareCard;
